import * as React from 'react';

import { twMerge } from 'utilities/src/twMerge';

import GenericIconProps from '../_icon.type';

export default function Youtube({ className = '', viewBox = '0 0 24 24', size }: GenericIconProps) {
  return (
    <svg
      className={twMerge(className, size)}
      viewBox={viewBox}
      width="24"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M23.5002 6.62364C23.2236 5.59039 22.4116 4.7784 21.3783 4.50181C19.5054 4 12 4 12 4C12 4 4.49457 4 2.62364 4.50181C1.59039 4.7784 0.7784 5.59039 0.501811 6.62364C0 8.49457 0 12.4004 0 12.4004C0 12.4004 0 16.3062 0.501811 18.1771C0.7784 19.2104 1.59039 20.0224 2.62364 20.299C4.49457 20.8008 12 20.8008 12 20.8008C12 20.8008 19.5054 20.8008 21.3764 20.299C22.4096 20.0224 23.2216 19.2104 23.4982 18.1771C24 16.3062 24 12.4004 24 12.4004C24 12.4004 24 8.49457 23.4982 6.62364H23.5002ZM9.5996 16V8.80079L15.8347 12.4004L9.5996 16Z" />
    </svg>
  );
}
